import * as i1 from '@angular/cdk/a11y';
import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { ButtonTestIDs, ButtonStyle, ButtonDefaults } from '@kui-shared/button';
import { CommonModule } from '@angular/common';

class ButtonDirective {
    get testId() {
        return ButtonTestIDs.Button;
    }
    get className() {
        return this._buttonStyle;
    }
    constructor(_elementRef, _focusMonitor) {
        this._elementRef = _elementRef;
        this._focusMonitor = _focusMonitor;
        this._buttonStyle = '';
    }
    ngOnInit() {
        this._updateStyle();
    }
    ngOnChanges() {
        this._updateStyle();
    }
    focus(origin, options) {
        const { nativeElement } = this._elementRef;
        if (origin) {
            this._focusMonitor.focusVia(nativeElement, origin, options);
        }
        else {
            nativeElement.focus(options);
        }
    }
    _updateStyle() {
        this._buttonStyle = ButtonStyle({
            css: this.css,
            danger: this.danger ?? ButtonDefaults.danger,
            size: this.size ?? ButtonDefaults.size,
            tone: this.tone ?? ButtonDefaults.tone,
        }).className;
    }
}
ButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: ButtonDirective, deps: [{ token: i0.ElementRef }, { token: i1.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive });
ButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.1.4", type: ButtonDirective, selector: "button[kuiButton]", inputs: { css: "css", danger: "danger", size: "size", tone: "tone" }, host: { properties: { "attr.data-testid": "this.testId", "class": "this.className" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: ButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[kuiButton]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.FocusMonitor }]; }, propDecorators: { testId: [{
                type: HostBinding,
                args: ['attr.data-testid']
            }], className: [{
                type: HostBinding,
                args: ['class']
            }], css: [{
                type: Input
            }], danger: [{
                type: Input
            }], size: [{
                type: Input
            }], tone: [{
                type: Input
            }] } });

class ButtonModule {
}
ButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: ButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.1.4", ngImport: i0, type: ButtonModule, declarations: [ButtonDirective], imports: [CommonModule], exports: [ButtonDirective] });
ButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: ButtonModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.4", ngImport: i0, type: ButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ButtonDirective],
                    imports: [CommonModule],
                    exports: [ButtonDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonDirective, ButtonModule };
